export const FETCHED_FEED_SUCCESSFULLY = "FETCHED_FEED_SUCCESSFULLY";
export const DIRECT_APPOINTMENT = "direct";
export const FUTURE_APPOINTMENT = "future";